import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

/**
 * Куда AppLayout выводит полноэкранные оверлеи — сиблинг хэдера,
 * `.main` и нижнего бара, а не потомок прокручиваемого `.main`.
 */
export const OVERLAY_ROOT_ID = 'app-overlay-root';

/**
 * Полноэкранный оверлей из глубины страницы — в корень холста.
 *
 * `position: fixed` внутри `.layout` считается от него (transform: scale
 * создаёт containing block), и геометрия у оверлея одна и та же, где бы он
 * ни лежал в DOM. А вот слой — нет. В WebKit на iOS прокручиваемый
 * контейнер (`.main`, overflow-y: auto) не выпускает z-index потомков
 * наружу: шторка Прогноза с `--z-modal` оставалась внутри слоя `.main`,
 * и хэдер — сиблинг с `--z-header` — рисовался ПОВЕРХ её верхней полосы,
 * ровно там, где крестик. В Chromium контейнер прокрутки стек-контекст
 * не создаёт, поэтому ни e2e, ни скриншоты этого не показывали; увидели
 * на живом iPhone 03.09.2026.
 *
 * Портал выносит оверлей из `.main` в сиблинга — тогда `--z-modal`
 * спорит с `--z-header` в одном контексте и выигрывает в любом движке.
 *
 * Корня нет (юнит без AppLayout) — рендерим на месте: тесту разметки
 * важно содержимое, а не слой.
 */
export function OverlayPortal({ children }: { children: ReactNode }) {
  const root = document.getElementById(OVERLAY_ROOT_ID);
  if (!root) return <>{children}</>;
  return createPortal(children, root);
}
